import React from "react";

const LOGO_URL = "/orbital-logo.png";

export default function OrbitalLogo({ size = 32, className = "" }) {
  return (
    <img
      src={LOGO_URL}
      alt="Orbital Exchange"
      width={size}
      height={size}
      className={`inline-block object-contain ${className}`}
      style={{ width: size, height: size }}
    />
  );
}
